import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import css from './IconFitness.module.css';

const IconFitness = props => {
  const { className, rootClassName } = props;
  const classes = clsx(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="21"
      height="25"
      viewBox="0 0 21 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 6C11.163 6 11.7989 5.73661 12.2678 5.26777C12.7366 4.79893 13 4.16304 13 3.5C13 2.83696 12.7366 2.20107 12.2678 1.73223C11.7989 1.26339 11.163 1 10.5 1C9.83696 1 9.20107 1.26339 8.73223 1.73223C8.26339 2.20107 8 2.83696 8 3.5C8 4.16304 8.26339 4.79893 8.73223 5.26777C9.20107 5.73661 9.83696 6 10.5 6Z"
        stroke="#6E7191"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1 8H20" stroke="#6E7191" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M9 8V13H12V8H9Z" fill="#6E7191" stroke="#6E7191" strokeWidth="1.8" />
      <path
        d="M8.1 24C8.1 24.4971 8.50294 24.9 9 24.9C9.49706 24.9 9.9 24.4971 9.9 24H8.1ZM9 14V13.1H8.1V14H9ZM12 14L12.6833 13.4143L12.4139 13.1H12V14ZM15 17.5L15.477 18.2632C15.6993 18.1242 15.85 17.8952 15.8897 17.6361C15.9293 17.3769 15.854 17.1133 15.6833 16.9143L15 17.5ZM10.523 19.2368C10.1015 19.5002 9.97336 20.0555 10.2368 20.477C10.5002 20.8985 11.0555 21.0266 11.477 20.7632L10.523 19.2368ZM9.9 24V14H8.1V24H9.9ZM9 14.9H12V13.1H9V14.9ZM11.3167 14.5857L14.3167 18.0857L15.6833 16.9143L12.6833 13.4143L11.3167 14.5857ZM14.523 16.7368L10.523 19.2368L11.477 20.7632L15.477 18.2632L14.523 16.7368Z"
        fill="#6E7191"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconFitness.defaultProps = {
  className: null,
  rootClassName: null,
};

IconFitness.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconFitness;
